import { takeEvery, put } from 'redux-saga/effects';

import api from 'commons/api';
import notification from 'commons/notification';
import { mapFileService } from 'commons/services';
import { mapFileActions } from 'commons/store/mapFile';
import { appActions } from 'commons/store/app';

function* addNode({ payload }) {
  yield* api(
    mapFileService.addNode,
    payload,
    mapFileActions.updateTree,
    function*(err) {
      yield notification('MESSAGES.MAP.COULD_NOT_ADD_NODE', { type: 'error' });
    },
    { multiple: false }
  );
}

function* updateNode({ payload }) {
  yield* api(
    mapFileService.updateNode,
    payload,
    mapFileActions.updateTree,
    function*(err) {
      yield notification('MESSAGES.MAP.COULD_NOT_UPDATE_NODE', {
        type: 'error',
      });
    },
    { multiple: false }
  );
}

function* deleteNode({ payload }) {
  yield* api(
    mapFileService.deleteNode,
    payload,
    mapFileActions.updateTree,
    function*(err) {
      yield notification('MESSAGES.MAP.COULD_NOT_DELETE_NODE', {
        type: 'error',
      });
    },
    { multiple: false }
  );
}

function* addFiles({ payload }) {
  yield* api(
    mapFileService.addFiles,
    payload,
    function*(data) {
      yield put(appActions.hideGlobalDrawer());
      yield put(mapFileActions.updateTree(data));
    },
    function*(err) {
      yield notification('MESSAGES.MAP.COULD_NOT_ADD_FILES', { type: 'error' });
    }
  );
}

export default function*() {
  yield takeEvery(mapFileActions.addFiles.toString(), addFiles);
  yield takeEvery(mapFileActions.addNode.toString(), addNode);
  yield takeEvery(mapFileActions.updateNode.toString(), updateNode);
  yield takeEvery(mapFileActions.deleteNode.toString(), deleteNode);
}
